import routes from "@/utils/routes";
import NotFoundPage from "@/pages/NotFoundPage";
import { Spin } from "antd";
import { Suspense } from "react";
import { Outlet, useRoutes } from "react-router-dom";
import { ADMIN_PLATFORM_ROUTE_PREFIX } from "@/lib/adminPlatformPaths";

const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

function PlatformShell() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-[240px] w-full items-center justify-center">
          <Spin size="large" />
        </div>
      }
    >
      <Outlet context={ADMIN_PLATFORM_ROUTE_PREFIX} />
    </Suspense>
  );
}

function buildPlatformChildren() {
  const children = authRoutes.map(({ path, element: Page }) => {
    if (path === "/") {
      return { index: true, element: <Page /> };
    }
    return {
      path: path.startsWith("/") ? path.slice(1) : path,
      element: <Page />,
    };
  });
  children.push({ path: "*", element: <NotFoundPage /> });
  return children;
}

const platformRouteTree = [
  {
    path: "",
    element: <PlatformShell />,
    children: buildPlatformChildren(),
  },
];

export function AdminPlatformRoutes() {
  return useRoutes(platformRouteTree);
}
